export enum MandateStatus {
  ALL = "ALL",
  ACTIVE = "ACTIVE",
  CONSUMED = "CONSUMED",
  REVOKED = "REVOKED",
  OPPOSED = "OPPOSED",
  CREDITOR_OPPOSED = "CREDITOR_OPPOSED",
  OBSOLETE = "OBSOLETE",
}

export enum MandateStatusColor {
  SUCCESS = "success",
  WARNING = "warning",
  GRAY = "gray",
}

export const MANDATES_STATUSES: {
  [key in MandateStatus]: {
    label: string;
    color?: MandateStatusColor;
  };
} = {
  [MandateStatus.ALL]: {
    label: "mandates.status.all",
    color: MandateStatusColor.SUCCESS,
  },
  [MandateStatus.ACTIVE]: {
    label: "mandates.status.active",
    color: MandateStatusColor.SUCCESS,
  },
  [MandateStatus.OPPOSED]: {
    label: "mandates.status.opposed",
    color: MandateStatusColor.WARNING,
  },
  [MandateStatus.CONSUMED]: {
    label: "mandates.status.consumed",
    color: MandateStatusColor.GRAY,
  },
  [MandateStatus.REVOKED]: {
    label: "mandates.status.revoked",
    color: MandateStatusColor.WARNING,
  },
  [MandateStatus.CREDITOR_OPPOSED]: {
    label: "mandates.status.creditorOpposed",
    color: MandateStatusColor.GRAY,
  },
  [MandateStatus.OBSOLETE]: {
    label: "mandates.status.obsolete",
    color: MandateStatusColor.GRAY,
  },
};

export interface Mandate {
  id: string;
  reference: string;
  creditorRef: string;
  debtorRef: string;
  signatureDate: string;
  type: string;
  recurrent: boolean;
  originalMandate: {
    reference: string;
    creditorRef: string;
    type: string;
    debtorIban: string;
    debtorBic: string;
    debtorName: string;
    debtorCountry: string;
    debtorAddress: string;
    debtorZipCode: string;
  } | null;
  creditorName: string;
  isRevoked: boolean;
  status: string;
  lastCollectionDate: string | null;
}
